"use client";

import { Lock } from "lucide-react";
import React from "react";

export default function Footer() {
    return (
        <footer className="py-2" style={{ backgroundColor: '#b19872' }}>
            <div className="mx-auto px-1">
                <div className="flex flex-row items-center justify-between pl-5 pr-5 md:pl-14 md:pr-14">
                    <div className="flex flex-col">
                        <p className="text-white text-lg md:text-3xl font-monsieurLaDoulaise">
                            05 Décembre 2025
                        </p>
                    </div>
                    <div className="flex justify-center md:py-2">
                        <a
                            href="/admin"
                            target="_blank"
                            className="inline-flex items-center space-x-2 text-xl text-bordeaux-300 hover:text-white transition-colors opacity-60 hover:opacity-100"
                        >
                            <Lock className="w-3 h-3" />
                            <span>Espace privé</span>
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
